import axiosInstance from '@/utils/api.js'

var state = {
  rabbitMQServers: []
}

var getters = {
  RABBIT_MQ_SERVERS: (state) => {
    return state.rabbitMQServers
  }
}

var mutations = {
  SET_RABBIT_MQ_SERVERS: (state, payload) => {
    state.rabbitMQServers = payload
  }
}

var actions = {
  GET_RABBIT_MQ_SERVERS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/rabbitmq_servers')
    if (result.status === 200) {
      context.commit('SET_RABBIT_MQ_SERVERS', result.data)
    }
  },
  CREATE_RABBIT_MQ_SERVERS: (context, payload) => {
    return axiosInstance.post('/settings/rabbitmq_servers', payload)
  },
  UPDATE_RABBIT_MQ_SERVERS: (context, payload) => {
    return axiosInstance.put('/settings/rabbitmq_servers', payload)
  },
  DELETE_RABBIT_MQ_SERVERS: (context, payload) => {
    return axiosInstance.delete('/settings/rabbitmq_servers?rabbitmq_server_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/rabbitMQ.js